import React from 'react';
import jwtDecode from 'jwt-decode';
import { HyperdbForm } from '../../../../hyperdb';
import { Tabs, Tab, DropdownButton, MenuItem } from 'react-bootstrap';
import { Modal } from 'hyperdb-utils';
import { FILESTORE_URL } from '../../../../../config';
import { PictureForm } from '../../../inventory/common';
import { WebsiteTab } from '../components';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.toggleModalHomepageImage = this.toggleModalHomepageImage.bind(this);
    this.toggleModalPicture = this.toggleModalPicture.bind(this);
    this.handleChangePicture = this.handleChangePicture.bind(this);
    this.handleUploadPicture = this.handleUploadPicture.bind(this);
    this.toggleModalDeleteHomepageImage = this.toggleModalDeleteHomepageImage.bind(this);
    this.toggleModalDeletePicture = this.toggleModalDeletePicture.bind(this);
    this.handleDeletePicture = this.handleDeletePicture.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.uploadSuccess) {
      this.props.api.areaContent.setData({ uploadSuccess: false });
      if (nextProps.typePicture === 'picture') {
        const pictures = nextProps.objectData.pictures.slice();
        if (nextProps.indexEditedPicture === -1) {
          pictures.push(nextProps.savedPicture);
        } else {
          pictures[nextProps.indexEditedPicture] = nextProps.savedPicture;
        }
        this.props.api.areaContent.updateEditedObject({ attributeName: 'pictures', value: pictures });
        this.toggleModalPicture(false);
      } else {
        const websiteContent = { ...nextProps.objectData.website };
        websiteContent.image = nextProps.savedPicture;
        this.props.api.areaContent.updateEditedObject({ attributeName: 'website', value: websiteContent });
        this.toggleModalHomepageImage(false);
      }
    }
    if (nextProps.deletePictureSuccess) {
      this.props.api.areaContent.setData({ deletePictureSuccess: false });
      if (nextProps.typePicture === 'picture') {
        const pictures = nextProps.objectData.pictures.slice();
        pictures.splice(nextProps.indexDeletePicture, 1);
        this.props.api.areaContent.updateEditedObject({ attributeName: 'pictures', value: pictures });
        this.toggleModalDeletePicture(-1);
      } else {
        const websiteContent = { ...nextProps.objectData.website };
        websiteContent.image = null;
        this.props.api.areaContent.updateEditedObject({ attributeName: 'website', value: websiteContent });
        this.toggleModalDeleteHomepageImage(false);
      }
    }
  }
  componentDidMount() {
    const areaId = this.props.location.query.areaId || this.props.objectData.area.value[1];
    this.props.api.area.getObject(areaId);
    const reference = { ...this.props.objectData.area };
    reference.value[1] = areaId;
    this.props.api.areaContent.updateEditedObject({ attributeName: 'area', value: reference, noSetDirty: true });
  }
  render() {
    const websiteContent = this.props.objectData.website || {};
    const pictures = this.props.objectData.pictures || [];
    return (
      <div>
        <Tabs defaultActiveKey={1} id="content-form">
          <Tab eventKey={1} title="Website content">
            <WebsiteTab
              { ...this.props }
              websiteContent={ websiteContent }
              onChange={ this.handleChange.bind(this, 'website') }
              availableLocales={ this.props.availableLanguages }
              toggleModalHomepageImage={ this.toggleModalHomepageImage }
              showModalPicture={ this.props.showModalPicture && this.props.typePicture === 'websiteContent' }
              onChangePicture={ this.handleChangePicture }
              onUploadPicture={ this.handleUploadPicture }
              toggleModalDeleteHomepageImage={ this.toggleModalDeleteHomepageImage }
              showModalDeletePicture={ this.props.showModalDeletePicture && this.props.typePicture === 'websiteContent' }
              onDeletePicture={ this.handleDeletePicture }
            />
          </Tab>
          {
            this.props.objectData.id
              ? <Tab eventKey={2} title="Pictures">
                  <fieldset>
                    <div className="box-header">
                      <span>
                        <b>Pictures for area</b>
                        &nbsp;
                        <button type="button" className="btn btn-xs btn-primary" onClick={ this.toggleModalPicture.bind(this, true, -1) }>Add</button>
                      </span>
                    </div>
                    <div className="table-responsive no-padding">
                      <table className="table table-hover table-striped table-bordered table-responsive">
                        <thead>
                          <tr>
                            <th>Picture</th>
                            <th>Info</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            pictures.map((picture, i) => {
                              return (
                                <tr key={ i }>
                                  <td>
                                    <a href={ this.pictureUrl(picture, this.props.objectData.id, 'original') } target="_blank">
                                      <img src={ this.pictureUrl(picture, this.props.objectData.id, 'thumbnail') } alt="thumbnail" style={{maxWidth: '90px', maxHeight: '60px'}}/>
                                    </a>
                                  </td>
                                  <td>
                                    Filename: { picture.filename ? (picture.filename.$i18n || {})[this.props.defaultLanguage] : '' }
                                    <br/>
                                    Title: { picture.title ? (picture.title.$i18n || {})[this.props.defaultLanguage] : '' }
                                    <br/>
                                    Description: { picture.description ? (picture.description.$i18n || {})[this.props.defaultLanguage] : '' }
                                  </td>
                                  <td>
                                    <DropdownButton title={ <span><i className="fas fa-caret" /> Actions</span> } pullRight bsSize="small" id="Menu actions">
                                      <MenuItem onClick={ this.toggleModalPicture.bind(this, true, i) }>Edit</MenuItem>
                                      <MenuItem onClick={ this.toggleModalDeletePicture.bind(this, i) }>Delete</MenuItem>
                                    </DropdownButton>
                                  </td>
                                </tr>
                              );
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                    {
                      this.props.showModalPicture && this.props.typePicture === 'picture'
                        ? <Modal title="" onClose={ this.toggleModalPicture.bind(null, false) } onAccept={ this.handleUploadPicture } loading={ this.props.uploadingPicture }>
                            <PictureForm
                              { ...this.props }
                              object={ this.props.objectData }
                              picture={ this.props.editedPicture }
                              mode="short"
                              backendEntryPoint="/area-contents"
                              onChange={ this.handleChangePicture } />
                          </Modal>
                        : null
                    }
                    {
                      this.props.showModalDeletePicture && this.props.typePicture === 'picture'
                        ? <Modal title="Delete picture" onClose={ this.toggleModalDeletePicture.bind(null, -1) } onAccept={ this.handleDeletePicture } loading={ this.props.deletingPicture }>
                            Delete this picture ?
                            <br/>
                            { this.props.deletingPicture ? 'DELETING...' : '' }
                          </Modal>
                        : null
                    }
                  </fieldset>
                </Tab>
              : null
          }
        </Tabs>
      </div>
    );
  }

  handleChange(attributeName, value) {
    this.props.api.areaContent.updateEditedObject({ attributeName, value });
  }

  pictureUrl(picture, objectId, type) {
    const { currentUser } = this.props.api.getState('auth');
    const decoded = jwtDecode(currentUser.jwt);
    const fileId = picture[type] && picture[type].value ? picture[type].value.id : null;
    const fileName = picture[type] && picture[type].value ? picture[type].value.name : null;
    return `${FILESTORE_URL}/${decoded.client_id}/area-contents/${objectId}/${fileId}/${fileName}`;
  }

  toggleModalHomepageImage(bool) {
    const websiteContent = this.props.objectData.website;
    let editedPicture = null;
    if (bool) {
      editedPicture = websiteContent.image
        ? websiteContent.image
        : {};
    }
    this.props.api.areaContent.setData({ showModalPicture: bool, editedPicture, typePicture: 'websiteContent' });
  }
  toggleModalPicture(bool, indexEditedPicture = -1) {
    const pictures = this.props.objectData.pictures;
    const editedPicture = bool && indexEditedPicture !== -1
      ? { ...pictures[indexEditedPicture] }
      : {};
    this.props.api.areaContent.setData({ showModalPicture: bool, editedPicture, indexEditedPicture, typePicture: 'picture' });
  }
  handleChangePicture(picture) {
    this.props.api.areaContent.setData({ editedPicture: picture });
  }
  handleUploadPicture() {
    const editedPicture = this.props.editedPicture;
    if (!editedPicture.image && !editedPicture._new) return null;
    const typePicture = this.props.typePicture;
    this.props.api.areaContent.savePicture({ typePicture, contentId: this.props.objectData.id, picture: editedPicture });
  }
  toggleModalDeleteHomepageImage(bool) {
    this.props.api.areaContent.setData({ showModalDeletePicture: bool, typePicture: 'websiteContent' });
  }
  toggleModalDeletePicture(indexDeletePicture = -1) {
    const showModalDeletePicture = indexDeletePicture !== -1;
    this.props.api.areaContent.setData({ showModalDeletePicture, indexDeletePicture, typePicture: 'picture' });
  }
  handleDeletePicture() {
    const typePicture = this.props.typePicture;
    const pictureId = typePicture === 'websiteContent'
      ? this.props.objectData.website.image.id
      : this.props.objectData.pictures[this.props.indexDeletePicture].id;
    this.props.api.areaContent.deletePicture({ typePicture, contentId: this.props.objectData.id, pictureId });
  }
}

export default HyperdbForm(Form, {
  namespace: 'areaContent',
  mountedUrl: '/content/areas',
  titleNew: 'Create content for area',
  titleEdit: 'Edit content for area',
  displayName: (o, props) => {
    const area = props.api.getState('area').objectData || { name: {} };
    return area.name.$i18n;
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/content/area-content/containers/Form.jsx